/**
 * Product card delivery line, switched by the colour swatch.
 * A/B: MC_COLLECTION_DELIVERYANDFEATUREONCARD_LB24
 *
 * The card has no product form, so <variant-inventory> (which listens for a form's "variant:change") cannot
 * drive this — hence the small listener here.
 *
 * Delegated on document and attached unconditionally:
 *  - the collection results are replaced wholesale when a facet changes, so a listener bound to the cards
 *    themselves would be thrown away with them;
 *  - the theme guards some of its own listeners behind feature checks that silently no-op when a script
 *    loads later than the section.
 *
 * The CTA does NOT need anything here: ProductCard._onSwatchChanged already rewrites every
 * a[href^=product.url] in the card to carry ?variant=<id>.
 */
(() => {
  const SWATCH_SELECTOR = '.product-card__swatch-list input[type="radio"], .product-card__variant-list input[type="radio"]';

  function syncDeliveryLine(input) {
    const card = input.closest('product-card');
    if (!card) return;

    const container = card.querySelector('[data-pc-delivery]');
    if (!container) return;

    // Only react to the option the delivery spans are keyed by.
    const fieldset = input.closest('[data-option-position]');
    const optionPosition = container.getAttribute('data-option-position');
    if (fieldset && optionPosition && fieldset.getAttribute('data-option-position') !== optionPosition) return;

    const spans = container.querySelectorAll('[data-option-value]');
    if (!spans.length) return;

    // Two passes: a colour whose delivery text could not be resolved has no span at all, and flipping to
    // "nothing visible" there would read as a broken card. Leave the previous line standing instead.
    let match = null;
    spans.forEach((span) => {
      if (span.getAttribute('data-option-value') === input.value) match = span;
    });
    if (!match) return;

    spans.forEach((span) => span.toggleAttribute('hidden', span !== match));
  }

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input || typeof input.closest !== 'function') return;
    if (!input.matches(SWATCH_SELECTOR)) return;

    syncDeliveryLine(input);
  });
})();
